<div class="input-container">
  <input
    class="w-full font-normal"
    type="text"
    placeholder="Search..."
    pInputText
    [(ngModel)]="filter"
    />
  @if (filter().length) {
    <button (click)="onClear()"><i class="fa-solid fa-xmark fa-lg text-slate-400"></i></button>
  }
</div>
